import { NotFoundPageComponent } from '@aston/foundation';
import { Routes, RouterModule } from '@angular/router';
import { NgModule, inject } from '@angular/core';

import { AuthenticationIssuePageComponent } from './authentication-module/pages/authent-issue-page/authentication-issue-page.component';
import { AuthenticationLayoutComponent } from './authentication-module/layouts/authentication-layout/authentication-layout.component';
import { LoginCallbackPageComponent } from './authentication-module/pages/callback-page/callback-page.component';
import { MasterLayoutComponent } from './shared-module/layouts/master-layout/master-layout.component';
import { MobileLayoutComponent } from './shared-module/layouts/mobile-layout/mobile-layout.component';
import { LoginPageComponent } from './authentication-module/pages/login-page/login-page.component';
import { AuthenticationGuard, AnonymousGuard } from './authentication-module/guards';
import { DashboardRoutesService } from './shared-module/services/home.route.service';
import * as RoutesDefinitions from './routes-definitions';


const routes: Routes = [
	// Redirects to login page
	{path: '', pathMatch: 'full', redirectTo: (_route, hrs = inject(DashboardRoutesService)) => hrs.homeRouteForCurrentUser() },

	// Authentication process pages
	{
		path: RoutesDefinitions.AuthenticationRoutePath, component: AuthenticationLayoutComponent,
		children: [
			{
				path: RoutesDefinitions.LoginRoutePath, component: LoginPageComponent, canActivate: [AnonymousGuard],
				data: {titleTranslationKey: 'Login', layoutName: 'login'}
			},
			{
				path: RoutesDefinitions.AuthenticationIssueRoutePath, component: AuthenticationIssuePageComponent,
				data: {titleTranslationKey: 'Login', layoutName: 'authentication-issue'}
			},

			{
				path: RoutesDefinitions.LoginCallbackRoutePath, component: LoginCallbackPageComponent,
				data: {titleTranslationKey: 'Login', layoutName: 'login'}
			},
		]
	},

	// Authenticated service pages
	{
		path: '', 
		component: MasterLayoutComponent,
		canActivate: [AuthenticationGuard],
		data: {titleTranslationKey: 'Root'},
		children: [
			{
				path: 'not-found',
				component: NotFoundPageComponent,
				data: {titleTranslationKey: 'NotFound'},
			},

			// Bookstack service pages
			{
				path: 'help', 
				data: {titleTranslationKey: 'Root'},
				children: [
					{
						path: 'getting-started',
						data: { token: 'books/notes-de-version/page/notes-de-version' },
						loadComponent: () => import('@aston/context-help').then(m => m.ContextHelpPageComponent)
					},
				]
			},
		]
	},

	// Authenticated mobile pages
	{
		path: RoutesDefinitions.MobileRoutePath, 
		component: MobileLayoutComponent,
		canActivate: [AuthenticationGuard],
		data: {titleTranslationKey: 'Root'},
		loadChildren: () => import('./mobile-module/mobile.routing'),
	},

	// Authenticated pages
	{
		path: '', 
		component: MasterLayoutComponent,
		canActivate: [AuthenticationGuard],
		data: {titleTranslationKey: 'Root'},
		children: [
			{path: 'welcome', pathMatch: 'prefix', redirectTo: RoutesDefinitions.PlatformHomePageRoutePath},
			{
				path: RoutesDefinitions.PlatformHomePageRoutePath,
				data: { titleTranslationKey: 'Home', },
				children: [
					{
						path: '',
						pathMatch: 'full',
						redirectTo: () => inject(DashboardRoutesService).homeRouteForCurrentUser()
					},
					{
						path: '',
						pathMatch: 'prefix',
						loadChildren: () => import('./home-module/home-routing.module'),
					},
				]
			},
			{
				path: RoutesDefinitions.AccountingDocsListRoutePath,
				loadChildren: () => import('./accounting-module/accounting-routing.module')
			},
			{
				path: RoutesDefinitions.DunningRoutePath,
				loadChildren: () => import('./dunnings-module/dunnings-routing.module')
			},
			{
				path: RoutesDefinitions.DunningSettingRoutePath,
				loadChildren: () => import('./dunning-settings-module/dunning-settings-routing.module')
			},
			{
				path: RoutesDefinitions.ImportManualFullRoutePath,
				loadChildren: () => import('./import-manual-module/import-manual.module')
			},
			{
				path: RoutesDefinitions.ImportPath,
				loadChildren: () => import('./import-module/import-routing.module')
			},
			{
				path: RoutesDefinitions.AdminToolsPath,
				loadChildren: () => import('./admin-module/admin-routing.module')
			},
			{
				path: RoutesDefinitions.SuperDebtorsListRoutePath,
				loadChildren: () => import('./debtors-module/debtors-routing.module')
			},
			{
				path: RoutesDefinitions.NotificationsDashboardRoutePath,
				loadChildren: () => import('./notifications-module/notifications-routing.module')
			},
		]
	},

	// Default redirection
	{path: '**', redirectTo: RoutesDefinitions.getHomeFullPath()}
];

@NgModule({
	imports: [RouterModule.forRoot(routes,
		{enableTracing: false}
	)],
	exports: [RouterModule]
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AppRoutingModule {
}
